/* eslint-disable jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */
import React, { useState } from 'react'

export const DataDebug = ({ initExpanded, title, children }) => {
    const [expanded, setExpanded] = useState(initExpanded)

    return (
        <div
            style={{
                borderRadius: 4,
                background: '#f6f8fa',
                boxShadow: '0 0 1px  #eee inset',
            }}
        >
            <div
                style={{
                    fontSize: 11,
                    borderTopLeftRadius: 4,
                    borderTopRightRadius: 4,
                    fontWeight: 500,
                    padding: '.5rem',
                    background: '#555',
                    color: '#fff',
                    letterSpacing: '1px',
                }}
                onClick={() => {
                    setExpanded(!expanded)
                }}
            >
                {title || 'Debug'}
            </div>
            {expanded && (
                <pre
                    style={{
                        fontSize: '.65rem',
                        padding: '.25rem .5rem',
                        overflowX: 'scroll',
                        whiteSpace: 'pre-wrap',
                    }}
                >
                    {children}
                </pre>
            )}
        </div>
    )
}
